import * as React from 'react';
import MatchInfo from './match-info';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { MatchListStoreModel } from '../match-list/utils/match-list-models';
import OddsGroup from './odds-group';
import FavoriteButton from '@om-fe/core/components/favorite-button/favorite-button';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import getSlice from '@om-fe/core/utils/get-slice';
import { DisciplineLiveStatus } from '@om-fe/models';
import { createBem } from '@om-fe/utils';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';

export interface EventItemPublicProps {
    readonly extraClassName?: string | string[];
    readonly isActive: boolean;
    readonly isExpanded?: boolean;
    readonly isExpandable?: boolean;
    readonly matchId: string;
    readonly sliceKey: string;
    readonly liveStatus?: DisciplineLiveStatus;
    readonly routeName?: RouteNames;
}

export interface EventItemStoreProps {
    readonly filteredMainMarketsList?: string[];
}

interface EventItemState {
    readonly isExpanded?: boolean;
}

const bem = createBem({
    name: 'EventItem',
});

// TODO: ADD MarketName from market

const nameGroup = bem('MatchDetails');
const nameGroupOdds = bem('OddsGroup');

export type EventItemProps = EventItemPublicProps
    & EventItemStoreProps;

class EventItemComponent extends React.PureComponent<EventItemProps, EventItemState> {
    constructor(props: EventItemProps) {
        super(props);
        const { isExpanded, isExpandable } = props;

        this.state = {};

        if (isExpandable) {
            this.state = {
                ...this.state,
                isExpanded,
            };
        }
    }

    getOddsGroupNode = (): React.ReactNode => {
        const { filteredMainMarketsList, matchId, sliceKey } = this.props;

        return (
            <div className={nameGroupOdds}>
                { filteredMainMarketsList && filteredMainMarketsList.map((mainMarketId: string) => {
                    return (
                        <OddsGroup
                            key={mainMarketId}
                            mainMarketId={mainMarketId}
                            matchId={matchId}
                            sliceKey={sliceKey}
                            inheritedBem={bem}
                        />
                    );
                })}
            </div>
        );
    };

    toggleExpanded = (): void => {
        const { isExpanded } = this.state;

        if (isExpanded === undefined) {
            return;
        }
        this.setState({
            isExpanded: !isExpanded,
        });
    };

    render() {
        const {
            extraClassName,
            filteredMainMarketsList,
            isActive,
            isExpandable,
            matchId,
            sliceKey,
            liveStatus,
            routeName,
        } = this.props;
        const { isExpanded } = this.state;

        if (!filteredMainMarketsList) {
            return null;
        }

        return (
            <div className={bem({
                modifiers: {
                    active: isActive,
                },
                extra: extraClassName,
            })}>
                <div className={nameGroup}>
                    <MatchInfo
                        matchId={matchId}
                        sliceKey={sliceKey}
                        routeName={routeName}
                    />
                </div>
                {
                    isExpandable &&
                    <button
                        className={bem('OddsCollapseBtn')}
                        onClick={this.toggleExpanded}
                    >
                        <GeneralIcon name={isExpanded ? 'arr-up' : 'arr-down'}/>
                    </button>
                }
                {isExpandable ? (
                    isExpanded && (
                        <>
                            {this.getOddsGroupNode()}
                            {liveStatus === DisciplineLiveStatus.LIVE && (
                                <FavoriteButton matchId={matchId}/>
                            )}
                        </>
                    )
                ) : (
                    <>
                        {this.getOddsGroupNode()}
                        {liveStatus === DisciplineLiveStatus.LIVE && (
                            <FavoriteButton matchId={matchId}/>
                        )}
                    </>
                )}
            </div>
        );
    }
}

const EventItem: React.ComponentType<EventItemPublicProps> = connect<EventItemStoreProps>(
    (state: AppState, props: EventItemPublicProps): EventItemStoreProps => {
        const { sliceKey, matchId } = props;
        const slice: MatchListStoreModel | undefined = getSlice<MatchListStoreModel>(state, sliceKey);

        if (!slice || !matchId) {
            return {};
        }

        const { filteredMainMarketsList } = slice;

        return {
            filteredMainMarketsList,
        };
    },
)(EventItemComponent);

export default EventItem;
